/*
 * <jc-size-guide>: wraps the size tables (snippets/jc-size-table.liquid). The snippet renders
 * every measurement as inches first with the centimeters in parentheses (cm kept in data-cm,
 * cells marked data-sg-done). Any plain data-cm cell without that mark is converted here.
 * Used by the size guide page and the PDP size guide modal.
 * On the page, ?sg=<guide> (e.g. ?sg=mens_footwear) pre-selects that category.
 */
if (!customElements.get('jc-size-guide')) {
  class JcSizeGuide extends HTMLElement {
    connectedCallback() {
      try {
        const cat = new URLSearchParams(window.location.search).get('sg');
        if (cat) {
          const radio = this.querySelector('#sgc-' + cat.replace(/[^a-z_]/gi, ''));
          if (radio) radio.checked = true;
        }
      } catch (e) {
        /* no URL params: the first category stays selected */
      }

      this.querySelectorAll('td[data-cm]').forEach((c) => {
        if (c.dataset.sgDone) return;
        const cm = c.textContent.trim();
        if (!cm) return;
        const inch = cm.replace(/(\d+(?:\.\d+)?)/g, (m) => Math.round(parseFloat(m) / 2.54));
        const parts = inch.split(/[-–]/);
        const disp = parts.length === 2 && parts[0] === parts[1] ? parts[0] : inch;
        c.innerHTML = disp + '″ <span class="sg__in">(' + cm + ' cm)</span>';
        c.dataset.sgDone = '1';
      });
    }
  }
  customElements.define('jc-size-guide', JcSizeGuide);
}
